export const sales = {
  title: 'المبيعات',
  currency: {
    code: 'MAD',
    symbol: 'درهم',
    position: 'after',
    decimalSeparator: ',',
    thousandSeparator: ' '
  },
  columns: {
    num: 'رقم البيع',
    date: 'التاريخ',
    customer: 'العميل',
    total: 'المجموع',
    status: 'الحالة',
    paymentMethod: 'الدفع',
    paymentStatus: 'حالة الدفع',
    items: 'المنتجات',
    basicInfo: 'المعلومات الأساسية',
    financialInfo: 'التفاصيل المالية',
    systemInfo: 'معلومات النظام',
    createdAt: 'تاريخ الإنشاء',
    updatedAt: 'آخر تعديل'
  },
  filters: {
    search: {
      label: 'بحث',
      placeholder: 'البحث عن عملية بيع...'
    },
    sort: {
      label: 'ترتيب حسب',
      directions: {
        asc: 'تصاعدي',
        desc: 'تنازلي'
      }
    },
    status: {
      label: 'الحالة',
      placeholder: 'جميع الحالات',
      options: {
        completed: 'مكتملة',
        pending: 'قيد الانتظار',
        cancelled: 'ملغاة'
      }
    },
    paymentMethod: {
      label: 'طريقة الدفع',
      placeholder: 'جميع الطرق',
      options: {
        cash: 'نقدي',
        card: 'بطاقة',
        transfer: 'تحويل',
        check: 'شيك'
      }
    },
    paymentStatus: {
      label: 'حالة الدفع',
      placeholder: 'جميع الحالات',
      options: {
        paid: 'مدفوع',
        partial: 'مدفوع جزئياً',
        unpaid: 'غير مدفوع'
      }
    }
  },
  actions: {
    newSale: 'بيع جديد',
    view: 'عرض',
    edit: 'تعديل',
    delete: 'حذف',
    print: 'طباعة'
  },
  form: {
    title: {
      create: 'بيع جديد',
      edit: 'تعديل البيع'
    },
    customer: {
      label: 'العميل',
      placeholder: 'اختر عميلاً'
    },
    status: {
      label: 'الحالة',
      placeholder: 'اختر حالة'
    },
    paymentMethod: {
      label: 'طريقة الدفع',
      placeholder: 'اختر طريقة'
    },
    paymentStatus: {
      label: 'حالة الدفع',
      placeholder: 'اختر حالة'
    },
    items: {
      label: 'المنتجات',
      add: 'إضافة منتج',
      remove: 'حذف',
      product: 'المنتج',
      quantity: 'الكمية',
      unitPrice: 'سعر الوحدة',
      total: 'المجموع'
    },
    notes: {
      label: 'ملاحظات',
      placeholder: 'إضافة ملاحظات...'
    },
    total: 'المجموع',
    save: 'حفظ',
    update: 'تحديث',
    cancel: 'إلغاء',
    saving: 'جاري الحفظ...'
  },
  details: {
    title: 'تفاصيل البيع',
    customerInfo: 'معلومات العميل',
    saleInfo: 'معلومات البيع',
    noCustomer: 'لم يتم تحديد عميل',
    createdAt: 'تم الإنشاء في',
    updatedAt: 'تم التحديث في',
    itemName: 'المنتج',
    unitPrice: 'سعر الوحدة',
    close: 'إغلاق'
  },
  confirmations: {
    delete: 'هل أنت متأكد من حذف هذا البيع؟'
  },
  errors: {
    insufficientStock: 'المخزون غير كافٍ لواحد أو أكثر من المنتجات'
  },
  pagination: {
    totalItems: 'إجمالي المبيعات',
    itemsPerPage: 'المبيعات في الصفحة',
    page: 'الصفحة',
    of: 'من',
    next: 'التالي',
    previous: 'السابق',
    showing: 'عرض',
    to: 'إلى',
    of: 'من',
    items: 'مبيعات'
  }
}; 